import React from "react";
import moment from "moment";
import IconValueVisual from "../visuals/IconValueVisual";
import { Stack, Typography, styled } from "@mui/material";
import BadgeVisual from "../visuals/BadgeVisual";
const Card = styled(Stack)(({ theme }: any) => ({
  backgroundColor: "#fff",
  border: `2px solid ${theme.palette.common.backgroundGrey}`,
  minWidth: "310px",
  width: "310px",
  height: "352px",
  padding: "25px 15px",
}));

const StyledImageBox = styled("div", {
  shouldForwardProp: (prop: any) => prop !== "tag" && prop !== "src",
})<{ src: string; tag?: string; theme?: any }>(({ src }) => ({
  height: 160,
  width: "100%",
  background: `url(${src})`,
  backgroundSize: "auto",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  position: "relative",
  "& .tag": {
    position: "absolute",
    bottom: 0,
    right: 0,
  },
}));

interface ImageBoxInterface {
  tag?: string;
  src: string;
}
const ImageBox = ({ tag, src }: ImageBoxInterface) => {
  return (
    <StyledImageBox src={src} tag={tag}>
      {tag ? (
        <div className="tag">
          <BadgeVisual
            label={tag}
            color={tag === "conference" ? "primary" : "secondary"}
          />
        </div>
      ) : null}
    </StyledImageBox>
  );
};
interface UpcomingEventCardInterface {
  eventName: string;
  organizer: string;
  date?: string;
  time: string;
  location: string;
  eventDuration: string;
  src: string;
  tag?: string;
}
const defaultImg =
  "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWVldGluZ3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60";
const UpcomingEventCard = ({
  eventName,
  organizer,
  date,
  time,
  location,
  eventDuration,
  src,
  tag,
}: UpcomingEventCardInterface) => {
  return (
    <Card justifyContent="space-around">
      <Typography variant="h4">{eventName}</Typography>
      <Typography color="gray" variant="h4" fontWeight={400}>
        {organizer}
      </Typography>
      <ImageBox src={src ? src : defaultImg} tag={tag} />

      <Stack
        direction="row"
        alignItems="center"
        justifyContent={date && "space-around"}
      >
        {date ? (
          <Typography textAlign="center" color="primary" variant="h3">
            <span style={{ color: "#000", fontWeight: "normal", fontSize: 14 }}>
              {moment(date).format("dddd").substring(0, 3)}.
            </span>
            <br />
            {moment(date).format("MMMM")}
            <br />
            {moment(date).format("DD")}
          </Typography>
        ) : null}
        <Stack spacing={1.5}>
          <IconValueVisual value={eventDuration} icon="far fa-calendar-alt" />
          <IconValueVisual value={time} icon="fal fa-clock" />
          <IconValueVisual value={location} icon="fal fa-map-marker-alt" />
        </Stack>
      </Stack>
    </Card>
  );
};
export default UpcomingEventCard;
